/**
 * Created by Mikhail Menshenin on 20.08.2024
 */

const MapIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.map_json,
        targets: ["MapIcon"],
        control: "MapIcon"
    });

    this.hiddenByDefault = Object.values(cleverapps.Environment).filter((scene) => scene !== cleverapps.Environment.SCENE_GAME);

    this.resetState();
};

MapIcon.prototype = Object.create(SideBarIcon.prototype);
MapIcon.prototype.constructor = MapIcon;

MapIcon.prototype.resetState = function () {
    this.available = cleverapps.environment.isGameScene();
};

MapIcon.prototype.onPressed = function () {
    cleverapps.Scenes.GetRunningScene().sceneComponent.closeAction();
};

cleverapps.whenAllInitialized(() => {
    cleverapps.sideBar.addTemporaryIcon(new SlotMachineIcon());
    cleverapps.sideBar.addTemporaryIcon(new MapIcon());
});
